// src/pages/usa/colorado/Rifle.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

// ⭐ STRICT COMMAND: Rifle ALWAYS goes back to Colorado map
export const backRoute = "/map/colorado";

export default function Rifle() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly (NO LOOPS)
  useEffect(() => {
    if (!window.__rifleBackRouteSet) {
      window.__rifleBackRouteSet = true;
      navigate(".", { replace: true, state: { backRoute } });
    }
  }, [navigate]);

  return (

    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Rifle, Colorado</h1>

        <section className="travel-review">
          {/* LEFT COLUMN — TEXT */}
          <div className="travel-text">
            <h2>Discover Rifle, Colorado</h2>

            <p>
              Rifle, Colorado is a small town with big outdoor energy. Located in Garfield County
              along the Colorado River, it’s a launchpad for fishing, hiking, camping, and winter
              ice climbing. The town is best known for Rifle Falls State Park — a lush oasis
              featuring triple waterfalls, limestone caves, and a family-friendly loop trail.
            </p>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Elevation:</strong> ~5,400 ft
                </div>
              </li>
              <li>
                <div className="place-block">
                  <strong>Best seasons:</strong> Spring through Fall
                </div>
              </li>
              <li>
                <div className="place-block">
                  <strong>Nearby gems:</strong> Rifle Mountain Park, Roan Cliffs, Glenwood Canyon
                </div>
              </li>
            </ul>

            {/* GETTING THERE */}
            <h3>🚗 Getting There</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Route:</strong> Take I‑70 West from Denver
                </div>
              </li>
              <li>
                <div className="place-block">
                  <strong>Distance:</strong> ~180 miles
                </div>
              </li>
              <li>
                <div className="place-block">
                  <strong>Estimated Time:</strong> 3.5 hours
                </div>
              </li>
              <li>
                <div className="place-block">
                  <strong>Scenic Highlight:</strong> Glenwood Canyon — towering cliffs and river views
                </div>
              </li>
              <li>
                <div className="place-block">
                  <strong>Exit:</strong> Exit 90 toward Rifle
                </div>
              </li>
            </ul>

            <p>
              Pro tip: If you’re driving in winter, check CDOT for road conditions — Glenwood Canyon
              can be icy and unpredictable.
            </p>

            {/* PERSONAL OBSERVATION */}
            <h3>🌟 My Personal Observation</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Rifle Falls State Park:</strong> Once a single cascade, Rifle Falls was
                  reshaped in 1910 when a hydroelectric plant altered the water flow, splitting the
                  waterfall into the iconic three streams seen today. The park offers camping, picnic
                  areas, hiking trails, and limestone caves. Spring through summer is the best time
                  to visit, when the waterfalls are at their fullest.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=39.67756342543617,-107.69860982332523"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Rifle Falls State Park
                  </a>
                </div>
              </li>
            </ul>

            {/* HIDDEN GEMS */}
            <h3>⛰️ Hidden Gem in Rifle, Colorado</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Rifle Mountain Park Ice Caves:</strong> Just 15 miles north of Rifle Falls,
                  this limestone canyon transforms into a frozen wonderland each winter. From December
                  to February, narrow cave passages fill with turquoise ice walls and towering
                  icicles. Accessible via Kopers Trail — moderately easy and perfect for winter
                  explorers.
                </div>
              </li>
            </ul>

            {/* PLACES TO STAY */}
            <h3>🛏️ Places to Stay in Rifle</h3>

            <p>While I haven’t personally stayed overnight in Rifle, here are a few well-reviewed options:</p>

            <ul>
              <li>
                <div className="place-block">
                  <strong>La Quinta by Wyndham Rifle:</strong> Clean rooms, free Wi‑Fi, fitness center.
                </div>
              </li>
              <li>
                <div className="place-block">
                  <strong>Comfort Inn &amp; Suites:</strong> Indoor pool, spacious rooms, easy access to parks.
                </div>
              </li>
              <li>
                <div className="place-block">
                  <strong>Hampton Inn &amp; Suites Rifle:</strong> Terrace, indoor pool, 24‑hour front desk.
                </div>
              </li>
              <li>
                <div className="place-block">
                  <strong>Gateway Lodge:</strong> Budget‑friendly motel in downtown Rifle.
                </div>
              </li>
              <li>
                <div className="place-block">
                  <strong>Edge of the Wild – Guest House @ R Farm:</strong> Peaceful farm stay with views of the Roan Cliffs.
                </div>
              </li>
            </ul>

            {/* AFFILIATE BLOCK */}
            <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
                        <div className="affiliate-block">
                          <AffiliateExpedia />
                          <AffiliateBooking />
                          <AffiliateTrip />
                        </div>

            {/* VIDEOS */}
            <h3>🎥 My Travel Videos</h3>

            <p>Here is a video I took from Rifle Falls State Park:</p>

            <p>
              <a
                href="https://youtu.be/ucN-H-0C3p0?si=PciKo1kOn5seClZ8"
                target="_blank"
                rel="noopener noreferrer"
              >
                Rifle Falls State Park
              </a>
            </p>
          </div>

          {/* RIGHT COLUMN — IMAGES */}
          <div className="travel-image-column">
            <a
              href="https://youtu.be/ucN-H-0C3p0?si=PciKo1kOn5seClZ8"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/colorado/rifle/waterfall.jpg"
                alt="Rifle Waterfall Video"
              />
            </a>

            <img src="/images/usa/colorado/rifle/trail.jpg" alt="Trail" />
            <img src="/images/usa/colorado/rifle/trail2.jpg" alt="Trail" />
            <img src="/images/usa/colorado/rifle/cave.jpg" alt="Cave" />
            <img src="/images/usa/colorado/rifle/cave2.jpg" alt="Cave" />
          </div>
        </section>
      </div>

      {/* EMAIL BUTTON */}
      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      {/* POPUP */}
      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
